"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";

export const useClientRest = () => {
  const restDataProviderClient = createRestDataProviderClient();

  const clientConfig = useClientConfig();
  const token = clientConfig?.accessToken;

  const request = (params: { method: string; url: string; payload?: any; headers?: any; options?: any }) => {
    if (token) {
      params.options = {
        ...(params.options || {}),
        token,
      };
    }

    return restDataProviderClient.custom(params);
  };

  return { token, request };
};
